// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;The wicked are estranged, even from the womb;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;those who speak falsehood go astray from their birth.<br> </p> </div></div>";
// Exports
module.exports = code;